import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  selectValue: (isPlaceholder, isReadonly, isDisabled, showError, isSearchable) => {
    const getFontColor = () => {
      if (isDisabled) return 'darkGrey300';
      if (isPlaceholder) return 'darkGrey500';
      if (isReadonly) return 'darkGrey700';
      return 'darkGrey700';
    };
    return {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: isPlaceholder && !isSearchable ? 'flex-end' : 'space-between',
      position: 'relative',
      alignItems: 'center',
      p: '12px 16px',
      color: getFontColor(),
      ...reusables.mainTransition('color', 'cubic-bezier(.4,0,.2,1)', '.28s'),
      '&:hover': {
        ...(!isReadonly && !isDisabled && !showError ? {
          color: 'darkGrey700'
        } : null)
      }
    };
  },
  selectPlaceholder: (noValue, dropdownActive, showError) => {
    const condition = !noValue || dropdownActive;
    const getColor = () => {
      if (showError && condition && !dropdownActive) return 'darkGrey500';
      if (showError && !condition && dropdownActive) return 'accent700';
      return 'darkGrey500';
    };
    return {
      position: 'absolute',
      background: 'neutralWhite',
      top: condition ? 0 : '50%',
      p: condition ? '0 4px' : 0,
      lineHeight: condition ? '12px' : '16px',
      fontFamily: 'uniform',
      fontSize: condition ? '12px' : '16px',
      transform: condition ? 'translate(12px, -6px)' : 'translate(16px, -50%)',
      left: 0,
      color: getColor(),
      ...reusables.mainTransition('transform, fontSize, opacity, top, padding', 'cubic-bezier(.4,0,.2,1)', '.28s')
    };
  },
  selectNative: {
    display: 'none'
  },
  selectWrapper: (isReadonly, isDisabled, showError) => {
    const getBorderColor = () => {
      if (showError) return 'accent700';
      return 'lightGrey500';
    };
    return {
      width: '100%',
      height: '48px',
      maxHeight: '48px',
      mb: !showError ? '16px' : 0,
      borderWidth: '1px',
      borderStyle: 'solid',
      fontSize: 'text',
      borderColor: getBorderColor(),
      position: 'relative',
      display: 'flex',
      boxSizing: 'border-box',
      background: isDisabled ? 'lightGrey300' : 'neutralWhite',
      ...reusables.mainTransition('border-color', 'cubic-bezier(.4,0,.2,1)', '.28s'),
      '&:hover': {
        ...(!isReadonly && !isDisabled ? {
          borderColor: 'darkGrey300'
        } : null)
      },
      '&:focus': {
        // outline: '2px solid blue500',
        // outlineOffset: '2px',
      }
    };
  },
  selectDropdownElementButton: isSelected => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    minHeight: '41px',
    border: 'none',
    letterSpacing: 0,
    background: isSelected ? 'lightGrey300' : 'neutralWhite',
    userSelect: 'none',
    cursor: 'pointer',
    p: '5px 16px',
    textAlign: 'left',
    ...reusables.mainTransition('background', 'cubic-bezier(.4,0,.2,1)', '.28s'),
    '&:hover': {
      background: 'lightGrey500'
    },
    '&:first-of-type': {
      pt: '11px'
    },
    '&:last-of-type': {
      pb: '11px'
    }
  }),
  selectDropdownPanel: (isActive, maxHeight) => ({
    background: 'neutralWhite',
    p: 0,
    m: 0,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '50px',
    maxHeight,
    minWidth: 'calc(100% + 2px)',
    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.14)',
    overflow: 'hidden',
    position: 'absolute',
    border: `1px solid ${theme.rawColors.lightGrey700}`,
    zIndex: theme.zIndex.documentHigh,
    bottom: 0,
    left: '-1px',
    ...reusables.mainTransition('opacity transform border-color', 'cubic-bezier(.4,0,.2,1)', '.28s'),
    ...(isActive ? {
      transform: 'translateY(calc(100% - 1px))',
      opacity: 1,
      visibility: 'visible'
    } : {
      transform: 'translateY(calc(100% + 10px))',
      opacity: 0,
      visibility: 'hidden'
    })
  }),
  selectDropdownElementWrapper: {
    listStyleType: 'none',
    background: 'neutralWhite',
    pl: 0,
    m: 0,
    flex: 1,
    overflowY: 'auto'
  },
  selectValueInput: {
    flex: 1,
    minWidth: 0,
    width: '100%',
    height: '24px',
    border: 'none',
    background: 'transparent',
    p: 0,
    m: 0,
    fontFamily: 'uniform',
    fontSize: 'text',
    color: 'inherit',
    outline: 'none',
    cursor: 'text',
    '&::placeholder': {
      color: 'darkGrey500'
    }
  },
  selectNoResults: {
    p: '12px 16px',
    color: 'darkGrey500',
    fontFamily: 'uniform',
    fontSize: 'text'
  },
  selectDropdownIcon: isActive => ({
    transform: isActive ? 'rotate(180deg)' : 'rotate(0)',
    pointerEvents: 'none',
    ...reusables.mainTransition('transform', 'cubic-bezier(.4,0,.2,1)', '.28s')
  }),
  selectError: showError => ({
    display: showError ? 'flex' : 'none',
    mt: showError ? '4px' : 0,
    mb: '16px',
    marginLeft: '1rem',
    fontFamily: 'uniform',
    fontWeight: 'normal',
    fontSize: 'caption',
    color: 'accent700',
    height: showError ? '16px' : 0,
    transition: 'padding .3s linear'
  })
};